import { ADMIN_ALL } from 'constant/permissions'
import { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import {
    clearPermission,
    fetchOtherModuleAction,
} from 'store/actions/otherModuleAction.action'
import { useAppSelector } from 'store/useStoreHook'

export function usePermission() {
    const actions = useAppSelector((state) => state.auth.actionCodes)
    const user = useAppSelector((state) => state.auth.user)
    const pin = useAppSelector((state) => state.otherModuleAction.pin)
    const dispatch = useDispatch()
    const otherModuleAction = useAppSelector(
        (state) => state.otherModuleAction.otherModuleAction,
    )

    const isSuperAdmin = useMemo(() => {
        return actions.includes(ADMIN_ALL)
    }, [actions])

    const hasPermission = useCallback(
        (requirePermissions?: number[] | undefined) => {
            if (!requirePermissions) {
                return true
            } else if (requirePermissions.length > 0) {
                if (isSuperAdmin) return true

                return actions.some((s) => requirePermissions.includes(s))
            }

            return true
        },
        [actions, isSuperAdmin],
    )

    const hasPermissionWithOther = useCallback(
        (requirePermissions?: number[] | undefined) => {
            if (!requirePermissions) {
                return true
            }
            if (requirePermissions.length > 0) {
                if (isSuperAdmin) return true
                return [...otherModuleAction, ...actions].some((s) =>
                    requirePermissions.includes(s),
                )
            }

            return true
        },
        [otherModuleAction, actions, isSuperAdmin],
    )

    const fetchOtherModuleActionFromPin = useCallback(
        (pin: string) => {
            dispatch(fetchOtherModuleAction(pin))
        },
        [dispatch],
    )

    const isCurrentUser = useCallback(
        (compareUserId: string): boolean => {
            if (user?.userId === compareUserId) return true
            return false
        },
        [user?.userId],
    )
    const clearPermissionDispatch = useCallback(() => {
        dispatch(clearPermission())
    }, [dispatch])
    return {
        hasPermission,
        hasPermissionWithOther,
        fetchOtherModuleActionFromPin,
        isCurrentUser,
        actions,
        clearPermission: clearPermissionDispatch,
        pin,
    }
}

export default usePermission
